module.exports = __webpack_public_path__ + "img/university_18.cdf54d18.png";